export default {"src":"/_next/static/media/background_mobile.3ba6c09d.svg","height":491,"width":430,"blurWidth":0,"blurHeight":0};